import { Component, HostListener, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GapCheckQuestion } from '../../../../shared/models/gap-check-question';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './stepper.html',
})
export class StepperComponent {
  @Input() questions: { title: string; questions: GapCheckQuestion[] }[] = [];
  @Input() currentStep = 0;
  @Input() goToStep!: (i: number) => void;

  screenWidth: number = window.innerWidth;

  @HostListener('window:resize')
  onResize() {
    this.screenWidth = window.innerWidth;
  }
}
